// store/slices/executorSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../store";
import { ExecutorMeResponse } from "../../common/types/types";

interface ExecutorState {
  data: ExecutorMeResponse | null;
  isExecutor: boolean;
  isAdmin: boolean;
  clientUserId: number | null;
}

const initialState: ExecutorState = {
  data: null,
  isExecutor: false,
  isAdmin: false,
  clientUserId: null,
};

export const executorSlice = createSlice({
  name: "executor",
  initialState,
  reducers: {
    setExecutor: (state, action: PayloadAction<ExecutorMeResponse>) => {
      state.data = action.payload;
      state.isExecutor =
        action.payload.canServe &&
        action.payload.isActive &&
        !action.payload.isAdmin;
      state.isAdmin =
        action.payload.canServe &&
        action.payload.isActive &&
        action.payload.isAdmin === true;
    },
    clearExecutor: () => initialState,
    setClientUserId: (state, action: PayloadAction<number>) => {
      state.clientUserId = action.payload;
    },
    clearClientUserId: (state) => {
      state.clientUserId = null;
    },
  },
});

export const {
  setExecutor,
  clearExecutor,
  setClientUserId,
  clearClientUserId,
} = executorSlice.actions;

export const selectExecutor = (state: RootState) => state.executor.data;
export const selectIsExecutor = (state: RootState) => state.executor.isExecutor;
export const selectIsAdmin = (state: RootState) => state.executor.isAdmin;
export const selectExecutorStores = (state: RootState) =>
  state.executor.data?.stores || [];
export const selectClientUserId = (state: RootState) =>
  state.executor.clientUserId;

export default executorSlice.reducer;
